import { render, staticRenderFns } from "./myinfo-gender.vue?vue&type=template&id=5a23a0c6&"
import script from "./myinfo-gender.vue?vue&type=script&lang=js&"
export * from "./myinfo-gender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports